export default function AboutUs() {
  return (
    <section id="about" className="py-16 md:py-20 bg-gradient-to-b from-[#FFF8F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div className="w-full h-48 md:h-64">
              <img 
                src="https://public.readdy.ai/ai/img_res/e8d0fed61ee21148354c1281fcd669d2.jpg" 
                alt="Professional Attorney" 
                className="w-full h-full object-cover rounded-lg shadow-lg object-top"
              />
            </div>
            <div className="w-full h-48 md:h-64 mt-6 md:mt-8">
              <img 
                src="https://readdy.ai/api/search-image?query=Authentic%20Hispanic%20female%20legal%20professional%20in%20her%20thirties%20with%20brown%20skin%20and%20dark%20hair%20wearing%20professional%20business%20attire%20smiling%20warmly%20in%20a%20modern%20southwestern%20law%20office%2C%20genuine%20portrait%20of%20a%20Latina%20paralegal%20or%20legal%20assistant%20with%20natural%20features%20and%20friendly%20expression%2C%20realistic%20photography%20not%20AI%20generated&width=400&height=500&seq=about-real-staff-hispanic-002&orientation=portrait" 
                alt="Legal Team Member" 
                className="w-full h-full object-cover rounded-lg shadow-lg object-top"
              />
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              Why Should You Check With Us?
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
              Our mission is to put victims in touch with the best local medical providers and legal firms so that you <strong>collect the compensation that is due you today!</strong>
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
              We are a <strong>locally owned and operated company</strong> ready to serve the Las Cruces area with quality customer service, resources, and information. Our deep roots in the community mean we understand the unique challenges faced by accident victims in Southern New Mexico.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-6 md:mb-8 leading-relaxed">
              With our network of local top medical providers, we will direct you to the best and most reliable attorney to file your claim, getting you compensated as soon as possible.
            </p>
            <div className="text-center">
              <a 
                href="#contact" 
                className="inline-block bg-[#D2691E] text-white px-8 py-3 sm:px-10 sm:py-4 md:px-16 md:py-5 rounded-full text-base sm:text-lg md:text-2xl font-extrabold hover:bg-[#A0522D] transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
              >
                Value Your Claim
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
